<template>
  <span
    class="d-inline-flex flex-row-reverse"
    style="direction: ltr"
  >
    {{ data.value }}
  </span>
</template>

<script>
import BaseDisplayType from './Base.vue'

export default {
  name: 'DatetimeDisplayType',
  extends: BaseDisplayType,
}
</script>

<style scoped>

</style>
